// extracted by mini-css-extract-plugin
module.exports = {"success":"Alert_success__CBR1K","danger":"Alert_danger__n1yWx","error":"Alert_error__wqUsv","info":"Alert_info__2Tumd"};